import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './oktobizLogo.png';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: "LLC Formation", path: "/services/llc-formation" },
    { name: "Corporation Formation", path: "/services/corporation-formation" },
    { name: "Compliance (BOI)", path: "/services/compliance" },
    { name: "Licensing and guidance", path: "/services/licensing" },
  ];

  const resources = [
    { name: "LLC vs. Corporation", path: "/resources/llc-vs-corporation" },
    { name: "S-Corporation vs. C-Corporation", path: "/resources/scorp-vs-ccorp" },
    { name: "What is an EIN?", path: "/resources/employer-id-number" },
    { name: "What is BOI?", path: "/resources/beneficial-Ownership-info" },
  ];

  const support = [
    { name: "Contact us", path: "/contact-us" },
    { name: "Legal Disclaimer", path: "#" },
    { name: "Privacy Policy", path: "#" },
    { name: "Terms of Service", path: "#" },
    { name: "Cancellation policy", path: "#" },
  ];

  return (
    <footer className="bg-[#0f172a] text-slate-300 font-sans border-t border-slate-800/90 pt-12 pb-8">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Top Header with Logo */}
        <div className="pb-8 border-b border-slate-800/80 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center">
            <img src={Logo} alt="OKTOBIZ" className="h-[36px] lg:h-[42px] w-auto object-contain" />
          </Link>
          <div className="hidden sm:flex items-center gap-2 text-xs text-slate-400">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block animate-pulse"></span>
            <span>State Filing Services Active</span>
          </div>
        </div>

        {/* 4-Column Structured Content Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 py-10 border-b border-slate-800/80">
          {/* Column 1: Services */}
          <div>
            <h3 className="text-base font-semibold text-white tracking-wide mb-4">
              Services
            </h3>
            <ul className="flex flex-col space-y-2.5">
              {services.map((item, idx) => (
                <li key={idx} className="!block">
                  <Link
                    to={item.path}
                    className="text-slate-400 hover:text-white transition-all duration-150 inline-flex items-center gap-2 text-[14px] group"
                  >
                    <i className="fa-solid fa-chevron-right text-[10px] text-slate-600 group-hover:text-[#1a73e8] group-hover:translate-x-0.5 transition-all"></i>
                    <span>{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2: Resources */}
          <div>
            <h3 className="text-base font-semibold text-white tracking-wide mb-4">
              Resources
            </h3>
            <ul className="flex flex-col space-y-2.5">
              {resources.map((item, idx) => (
                <li key={idx} className="!block">
                  <Link
                    to={item.path}
                    className="text-slate-400 hover:text-white transition-all duration-150 inline-flex items-center gap-2 text-[14px] group"
                  >
                    <i className="fa-solid fa-chevron-right text-[10px] text-slate-600 group-hover:text-[#1a73e8] group-hover:translate-x-0.5 transition-all"></i>
                    <span>{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Support */}
          <div>
            <h3 className="text-base font-semibold text-white tracking-wide mb-4">
              Support
            </h3>
            <ul className="flex flex-col space-y-2.5">
              {support.map((item, idx) => (
                <li key={idx} className="!block">
                  <Link
                    to={item.path}
                    className="text-slate-400 hover:text-white transition-all duration-150 inline-flex items-center gap-2 text-[14px] group"
                  >
                    <i className="fa-solid fa-chevron-right text-[10px] text-slate-600 group-hover:text-[#1a73e8] group-hover:translate-x-0.5 transition-all"></i>
                    <span>{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Prominent Contact & Phone Number */}
          <div className="flex flex-col justify-start">
            <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">
              Toll-Free Helpline
            </h3>
            <a
              href="tel:855-658-6249"
              className="text-2xl sm:text-3xl font-extrabold text-white hover:text-[#1a73e8] transition-colors tracking-tight block mb-3"
            >
              855-OKTOBIZ
            </a>
            <p className="text-sm text-slate-400 leading-relaxed">
              5901 Chase Rd Suite 220<br />Dearborn, MI 48126
            </p>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>&copy; {currentYear} Oktobiz. All rights reserved.</p>
          <p className="text-slate-500">
            Document filing & formation assistance
          </p>
        </div>
      </div>
    </footer>
  );
}
